import { imagePrefix } from '@/constants';
import React, { memo } from 'react';
import waitingIcon from '@/assets/image/waiting.png';
import 'video.js/dist/video-js.css';
import styles from './index.less';
import Video from './video';
import MicePlayer from './mice';


interface PlayerHoc {
  url?: string;
  jobId?: string;
  poster?: string;
  autoHeight?: boolean;
  getVideo?: (val: any) => void
}
const PlayerHoc: React.FC<PlayerHoc> = (props) => {
  if (props.url) {
    return <Video {...props} key={props.url}></Video>
  }
  if (props.jobId) {
    return <MicePlayer {...props} key={props.jobId}></MicePlayer>
  }

  // 没有直播和视频
  return (
    <div
      className={styles.noData}
      style={{ backgroundImage: `url(${imagePrefix('default-cover.png')})` }}
    >
      <div className={styles.text}>
        <img src={waitingIcon} alt="" />
        直播未开始，敬请期待！
      </div>
    </div>
  )

}

export default memo(PlayerHoc);